import React from 'react';
import { painPoints } from '../data/content';
import { CTAButton } from './CTAButton';
export function PainPoints() {
  return <section className="w-full bg-cream px-4 py-12 sm:px-6 sm:py-16" data-id="element-196" data-mp="2lm0wbgl8jiwo">
      <div className="mx-auto max-w-3xl" data-id="element-197" data-mp="26z7o0va4vddz">
        <h2 className="text-center font-serif text-[27px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-198" data-mp="26y619tjr92gf">
          Si alguna vez te ha pasado esto…{' '}
          <span className="italic text-brand" data-id="element-199" data-mp="1xxhvtn8fgaf5">esta Ruta fue creada para ti</span>
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-200" data-mp="21zuslm574xzs">
          {painPoints.map(point => <li key={point.text} className="flex gap-3 rounded-xl border border-navy-100 bg-white p-4 shadow-card" data-id="element-201" data-mp="1nztolxtmxag3">
              <span aria-hidden="true" className="text-xl leading-none" data-id="element-202" data-mp="1sywwdq101urr">
                {point.emoji}
              </span>
              <p className="text-[14.5px] leading-relaxed text-navy-900/85" data-id="element-203" data-mp="3ibs1qav2eqh9">
                {point.text}
              </p>
            </li>)}
        </ul>

        <div className="mt-8 rounded-2xl bg-navy-900 p-6 text-center" data-id="element-204" data-mp="1yz3wix84u2gb">
          <p className="text-[15px] leading-relaxed text-navy-100" data-id="element-205" data-mp="1u2dgg9wbv6uw">
            La buena noticia es que ninguna de estas situaciones ocurre por falta
            de capacidad.
          </p>
          <p className="mt-3 font-serif text-[21px] font-bold leading-snug text-white sm:text-2xl" data-id="element-206" data-mp="23qvg2nsvf7wy">
            Ocurren porque nadie te enseñó a seguir una Ruta Clínica.
          </p>
          <p className="mt-3 text-[14px] font-semibold uppercase tracking-wide text-teal" data-id="element-207" data-mp="1b2zjdj3axg06">
            Y eso es exactamente lo que encontrarás aquí
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-208" data-mp="1p0egl9zsqs2p">
          <CTAButton label="Empezar a decidir con criterio" note="Garantía de 7 días · Sin riesgo" data-id="element-209" data-mp="1k34otnoxq4bp" />
        </div>
      </div>
    </section>;
}